import { BaseService } from '../../../../../core/services/base.service';
import {
  StageWithTemplates,
  TemplateId,
  Template,
} from '../models/templates.model';

export class TemplatesService {
  static async Post(
    statusId: string,
    template: Template
  ): Promise<StageWithTemplates> {
    return await BaseService.Post(`/statuses/${statusId}/templates`, {
      name: template.name,
      template: template.template,
    });
  }

  static async Patch(
    statusId: string,
    templateId: string,
    template: Template
  ): Promise<StageWithTemplates> {
    return await BaseService.Patch(
      `/statuses/${statusId}/templates/${templateId}`,
      {
        name: template.name,
        template: template.template,
      }
    );
  }

  static async Delete(
    statusId: string,
    templateId: string
  ): Promise<TemplateId[]> {
    return await BaseService.Delete(
      `/statuses/${statusId}/templates/${templateId}`
    );
  }
  static async GetPlaceholders(): Promise<string[]> {
    return await BaseService.Get('/statuses/placeholders');
  }
}
